<script setup>

import dayjs from "dayjs";
import {getPropertyName} from "@/helper.js";
import Card from "@/Components/Card.vue";
import Badge from "@/Components/Badge.vue";
import {route} from "ziggy-js";
import {Link} from "@inertiajs/vue3";
import OrderStatus from "@/Components/OrderStatus.vue";

const props = defineProps({
    code: {
        type: String,
        default: null,
    },
    createDate: {
        type: String,
    },
    lot: Object,
    offer_properties: Array,
    status: {
        type: String,
        default: null
    },
    product: Object
})

</script>

<template>
    <card class="px-2 pb-2">
        <div v-if="code" class="p-3 flex justify-between">
            <div>
                <div class="dark:text-slate-200 text-xl font-bold leading-120">{{$t('Order :code', {code: code})}}</div>
                <div class="dark:text-slate-200 text-xs leading-120 font-normal">
                    {{ dayjs(createDate).format('DD.MM.YYYY HH:mm') }}
                </div>
            </div>
            <div>
                <OrderStatus :status="status" :rename="{value: 'new', label: $t('Not paid')}"/>
            </div>

        </div>
        <div v-else class="px-3 py-5">
            <div class="dark:text-slate-200 text-xl font-semibold leading-120">{{ $t('Ordering') }}</div>
        </div>
        <div class="flex gap-2.5 px-3.5 py-1 ">
            <div class="w-[4.375rem] h-[4.375rem] lg:w-30 lg:h-30 shrink-0">
                <img class="w-full h-full rounded-lg" :src="product.image_url" :alt="product.title">
            </div>
            <div class="lg:px-2.5 text-xl font-medium tracking-wider">
                <div class="dark:text-slate-200 px-2.5 pb-1.25 lg:py-1.25 border-b border-dashed leading-full w-full transition-colors hover:text-slate-400">
                    <Link :href="lot.slug
                        ? route('products.lot', {product, lot: lot.slug})
                        : route('products.show', {product, lot_id: lot.id})">
                        {{ lot.title }}
                    </Link>
                </div>
                <div class="dark:text-slate-200 px-2.5 py-1.5 lg:py-1.25 border-b border-dashed leading-120 w-full transition-colors hover:text-slate-400">
                    <Link :href="route('products.show', product)">
                        {{ product.title }}
                    </Link>
                </div>
            </div>
        </div>
        <div class="p-2.5 ">
            <div class="px-1 flex flex-wrap gap-1">
                <template v-for="property in offer_properties">
                    <badge type="primary" :content-classes="['h-6', 'tracking-wide', 'px-2.5 py-1.25']">
                        <template #content>
                            <span class="align-middle">{{ getPropertyName(property) }}</span>
                        </template>
                    </badge>
                </template>
            </div>

        </div>
    </card>
</template>

<style scoped>

</style>
